var _rect, _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgFinanceFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51077 4.83103C1.19622 4.83103 0.891013 4.87104 0.59996 4.94625C0.821066 4.7259 1.10707 4.56573 1.4359 4.49907L14.4471 1.86134C15.3402 1.68029 16.211 2.25751 16.392 3.15061L16.7366 4.85025C16.6131 4.83754 16.4877 4.83103 16.3608 4.83103H1.51077Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24995 5.77982C1.04873 5.77982 0.0749512 6.7536 0.0749512 7.95481V15.4548C0.0749512 16.656 1.04873 17.6298 2.24995 17.6298H15.7499C16.9512 17.6298 17.9249 16.656 17.9249 15.4548V7.95481C17.9249 6.7536 16.9512 5.77982 15.7499 5.77982H2.24995ZM13.575 7.12981H15.825C16.2392 7.12981 16.575 7.46559 16.575 7.87981V10.1298L13.575 7.12981ZM1.42499 15.5298V13.2798L4.42499 16.2798H2.17499C1.76077 16.2798 1.42499 15.944 1.42499 15.5298ZM4.42499 7.12981L1.42499 10.1298V7.87981C1.42499 7.46559 1.76077 7.12981 2.17499 7.12981H4.42499ZM13.575 16.2798H15.825C16.2392 16.2798 16.575 15.944 16.575 15.5298V13.2798L13.575 16.2798ZM5.99997 11.7048C5.99997 10.0894 7.30954 8.77982 8.92497 8.77982C10.5404 8.77982 11.85 10.0894 11.85 11.7048C11.85 13.3202 10.5404 14.6298 8.92497 14.6298C7.30954 14.6298 5.99997 13.3202 5.99997 11.7048Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceFilled);
export default __webpack_public_path__ + "static/media/financeFilled.2d62e83e552a08b49bd3670d4b7317db.svg";
export { ForwardRef as ReactComponent };